import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { deactivateTreasuryAccount } from '../treasuryAccountsEndpoints'
import { treasuryAccountKeys } from '../treasuryAccountsQueryKeys'

export function useDeactivateTreasuryAccountMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deactivateTreasuryAccount,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: treasuryAccountKeys.lists() })
    },
  })
}
